import loadable from '@loadable/component';

export const LoadableNotFoundPage = loadable(
  () => import(/* webpackChunkName: "NotFoundPage" */ './NotFoundPage'),
);
